export enum LIMIT_TYPES {
  BOAT = "boat",
  PROGRAM = "program",
  CUSTOM = "custom",
}

